import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorLabel from "../../../../../component/error_label";
import {
  actionEndorsementAdd,
  resetEndorsementAdd,
  actionEndorsementEdit,
  resetEndorsementEdit,
} from "../store/index";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import { actionPolicyList, resetPolicyList } from "../../list/store";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import moment from "moment";
import $ from "jquery";
import Select from "react-select";
import { downloadFile, numberWheelChange } from "../../../../../utils";
import { useDropzone } from "react-dropzone";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import Swal from "sweetalert2";

const EndorsementForm = (props) => {
  const { EndorsementAdd, EndorsementEdit } = useSelector((state) => ({
    ...state.formStore,
  }));

  const { PolicyList } = useSelector((state) => ({
    ...state.listStore,
  }));

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [policyDropdown, setPolicyDropdown] = useState([]);
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  const [policyData, setPolicyData] = useState([]);
  const [attachment, setAttachment] = useState([]);
  const [attachment2, setAttachment2] = useState([]);
  const [policyDetails, setPolicyDetails] = useState({});
  const [loading, setLoading] = useState(false)

  const [document, setDocument] = useState([]);
  const initialData = location.state?.data;
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      gst_perc: 18,
    },
  });

  const watchGst = watch("gst_perc");
  const watchEndoAmount = watch("net_amount");
  const watchTaxAmount = watch("gst_amount");
  const watchEndorsementType = watch("type");
  const dateFields = [
    "payment_date",
    "endorsement_date",
    "endorsement_effective_date",
  ];

  useEffect(() => {
    dispatch(actionPolicyList());
  }, []);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        window.open(downloadPolicy.data.url);
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  useEffect(() => {
    const makeValueNull = [
      "net_amount",
      "gst_perc",
      "gst_amount",
      "total_amount",
      "payment_date",
      "paid_through",
    ];
    if (watchEndorsementType != initialData?.type) {
      makeValueNull.forEach((fieldName) => {
        setValue(fieldName, null);
      });
    }
  }, [watchEndorsementType]);

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });

      dateFields.forEach((fieldName) => {
        if (initialData[fieldName]) {
          setValue(
            fieldName,
            moment(initialData[fieldName]).format("DD-MM-YYYY")
          );
        }
      });
      setDocument(initialData?.documents);
      setValue('net_amount', Number(initialData?.total_amount));
      setValue('paid_through', initialData?.paid_through)
      setValue('gst_perc', initialData?.gst_perc);
      setValue("endorsement_no", initialData?.endorsement_no);
      setSelectedPolicyId(initialData?.policy_id);
    }
  }, [initialData]);

  useEffect(() => {
    if (PolicyList) {
      dispatch(resetPolicyList());
      if (PolicyList.status) {
        setPolicyData(PolicyList.data.policyList);
        const PolicyDropdown = PolicyList?.data?.policyList?.map(
          (item, index) => ({
            label: item.policy_no,
            value: item.id,
          })
        );
        setPolicyDropdown(PolicyDropdown);
        setValue("policy_no", initialData?.policy_no);
      }
    }
  }, [PolicyList]);

  useEffect(() => {
    if (selectedPolicyId) {
      let idPolicy = policyData.find((item) => item.id === selectedPolicyId);
      if (idPolicy) {
        setPolicyDetails(idPolicy);
      }
    }
  }, [selectedPolicyId]);

  useEffect(() => {
    let taxAmount = 0;
    if (watchEndoAmount) {
      taxAmount = ((Number(watchEndoAmount) * Number(watchGst)) / 100).toFixed(
        2
      );
      setValue("gst_amount", taxAmount);
    }
  }, [watchEndoAmount, watchGst]);

  useEffect(() => {
    if (watchTaxAmount) {
      let endorsementTotalPremium =
        Number(watchEndoAmount) + Number(watchTaxAmount);
      setValue("total_amount", endorsementTotalPremium);
    }
  }, [watchTaxAmount]);

  const onDrop = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment.length < 100) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const onDrop2 = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment2.length < 3) {
      setAttachment2([...attachment2, ...acceptedFiles]);
    } else {
    }
  });

  const {
    getRootProps: getRootProps2,
    getInputProps: getInputProps2,
    fileRejections: fileRejections2,
  } = useDropzone({
    accept: {
      accept: [
        ".pdf",
        ".doc",
        ".docx",
        ".jpeg",
        ".jpg",
        ".png",
        ".xls",
        ".xlsx"
      ]
    },
    multiple: true,
    maxFiles: 3,
    maxSize: 5 * 1024 * 1024, // 5 MB file size limit
    onDrop: onDrop2,
  });

  const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <div key={file.path} className="text-danger mt-2 small">
      <strong>{file.name}</strong> - {(file.size / 1024 / 1024).toFixed(2)} MB
      {errors.map((e, index) => (
        <div key={index}> {e.message}</div>
      ))}
    </div>
  ));

  const removeFile2 = (file) => () => {
    const newFiles = [...attachment2];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment2(newFiles);
  };
  const removeAll2 = () => {
    setAttachment2([]);
  };

  const thumbs2 = attachment2?.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile2(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  useEffect(() => {
    if (EndorsementAdd) {
      dispatch(resetEndorsementAdd());
      $("#add_edit_endorsement").prop("disabled", false);
      if (EndorsementAdd.status === true) {
        setLoading(false)
        toast.success(EndorsementAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        setLoading(false)
        toast.error(EndorsementAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [EndorsementAdd]);

  useEffect(() => {
    if (EndorsementEdit) {
      dispatch(resetEndorsementEdit());
      $("#add_edit_endorsement").prop("disabled", false);
      if (EndorsementEdit.status === true) {
        setLoading(false)
        toast.success(EndorsementEdit.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        setLoading(false)
        toast.error(EndorsementEdit?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [EndorsementEdit]);


  useEffect(() => {

    if (Object.keys(policyDetails)?.length > 0) {
      setValue('gst_perc', policyDetails?.gst_perc)
      setValue('paid_through', policyDetails?.paid_through)
    }
  }, [policyDetails])


  const onSubmit = (data) => {
    dateFields.forEach((fieldName) => {
      if (data[fieldName]) {
        data[fieldName] = moment(data[fieldName], "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
      }
    });
    if (data?.endorsement_effective_date == undefined) {
      delete data?.endorsement_effective_date;
    }

    Object.keys(data).forEach((key) => {
      if (data[key] == undefined || data[key] == null) {
        delete data[key];
      }
    });
    const input = { ...data };
    input.policy_type = policyDetails?.policy_type;
    input.user_id = policyDetails?.user_id;
    input.policy_id = selectedPolicyId;
    let files = [];

    if (attachment2 && attachment2.length > 0) {
      attachment2.forEach((objImage, index) => {
        files.push({
          name: "file",
          value: objImage,
        });
      });
    }

    if (initialData) {
      $("#add-edit-endorsement-loader").removeClass("hidden");
      $("#add_edit_endorsement").prop("disabled", true);
      dispatch(actionEndorsementEdit({ input, files }));
      setLoading(true)
    } else {
      $("#add-edit-endorsement-loader").removeClass("hidden");
      $("#add_edit_endorsement").prop("disabled", true);
      dispatch(actionEndorsementAdd({ input, files }));
      setLoading(true)
    }
  };

  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            Endorsement {initialData ? "Edit" : "Add"}{" "}
            <h6
              className="text-white mb-0 cursor-pointer"
              onClick={(event) => {
                event.preventDefault();
                navigate(-1);
              }}
            >
              {" "}
              Back
            </h6>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <form
                  noValidate
                  autoComplete="Off"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="form-body">
                    <div className="row mb-3">
                      {/* {initialData && (
                        <div className="col-12 col-md-3 mb-3">
                          <div className="form-group">
                            <label className="label-control">ID</label>
                            <input
                              className="form-control"
                              id="endo_id"
                              name="endo_id"
                              readOnly
                              {...register("endo_id")}
                            />
                          </div>
                        </div>
                      )} */}
                      <div className="col-12 col-md-3 mb-3">
                        <label>Policy Number</label>

                        <div className="form-group">
                          <Controller
                            name="policy_id"
                            control={control}
                            defaultValue=""
                            rules={{ required: "This is required." }}
                            render={({ field }) => (
                              <select
                                className="form-control"
                                {...field}
                                value={field.value || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);

                                  const selected = policyDropdown.find(
                                    (p) => String(p.value) === value
                                  );

                                  if (selected) {
                                    setSelectedPolicyId(selected.value);
                                  }
                                }}
                              >
                                <option value="">Select</option>
                                {policyDropdown.map((policy) => (
                                  <option
                                    key={policy.value}
                                    value={String(policy.value)}
                                  >
                                    {policy.label}
                                  </option>
                                ))}
                              </select>
                            )}
                          />

                          {errors.policy_id && (
                            <ErrorLabel message={errors.policy_id.message} />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Endorsement Number
                          </label>
                          <input
                            className="form-control"
                            id="endorsement_no"
                            name="endorsement_no"
                            {...register("endorsement_no", {
                              // required: "This is required",
                            })}
                          />
                          {errors.endorsement_no && (
                            <ErrorLabel
                              message={errors.endorsement_no?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Endorsement Type
                            <span className="danger">*</span>
                          </label>
                          <select
                            id="type"
                            name="type"
                            className="form-control"
                            {...register("type", {
                              required: "This is required.",
                            })}
                          >
                            <option value="">Select Endorsement Type</option>
                            <option value="Financial">Financial</option>
                            <option value="Non-Financial">
                              Non-Financial{" "}
                            </option>
                            {/* {getPolicyDropdown()} */}
                          </select>
                          {errors.type && (
                            <ErrorLabel message={errors.type?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Endorsement Reason
                            <span className="danger">*</span>
                          </label>
                          <select
                            id="reason"
                            name="reason"
                            className="form-control"
                            {...register("reason", {
                              required: "This is required.",
                            })}
                          >
                            <option value="">Select Endorsement Reason</option>
                            {watchEndorsementType === "Financial" ? (
                              <>
                                <option value="NCB Recovery">
                                  NCB Recovery
                                </option>
                                <option value="RC Transfer">RC Transfer</option>
                                <option value="Accessory Addition">
                                  Accessory Addition
                                </option>
                                <option value="RTO Modification">
                                  RTO Modification
                                </option>
                              </>
                            ) : (
                              <>
                                (
                                <option value="Address Correction">
                                  Address Correction
                                </option>
                                <option value="Name Correction">
                                  Name Correction
                                </option>
                                <option value="Vehicle No Update">
                                  Vehicle No Update
                                </option>
                                )
                              </>
                            )}
                            <option value="Others">Others </option>
                          </select>
                          {errors.reason && (
                            <ErrorLabel message={errors.reason?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div class="form-group has-search">
                          <label for="endorsement_date" class="form-label">
                            Endorsement Date<span class="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="endorsement_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "endorsement_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // maxDate: watchPolicyStartDate,
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.endorsement_date && (
                            <ErrorLabel
                              message={errors.endorsement_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div class="form-group has-search">
                          <label
                            for="endorsement_effective_date"
                            class="form-label"
                          >
                            Endorsement Effective Date
                            <span class="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="endorsement_effective_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "endorsement_effective_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // maxDate: watchPolicyStartDate,
                                  enableTime: false,
                                }}
                              />
                            )}
                          // rules={{
                          //   required: "This is required.",
                          // }}
                          />
                          {errors.endorsement_effective_date && (
                            <ErrorLabel
                              message={
                                errors.endorsement_effective_date?.message
                              }
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            COPS Approval
                            <span className="danger">*</span>
                          </label>
                          <select
                            id="status"
                            name="status"
                            className="form-control"
                            {...register("status", {
                              required: "This is required.",
                            })}
                          >
                            <option value="">Select Endorsement Type</option>
                            <option value="Approved">Approved</option>
                            <option value="Reject">Reject</option>
                            <option value="Pending">Pending</option>
                          </select>
                          {errors.status && (
                            <ErrorLabel message={errors.status?.message} />
                          )}
                        </div>
                      </div>

                      {/* START: This Fileds Required only if endorsement type is Financial    */}

                      {watchEndorsementType === "Financial" && (
                        <>
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                Endorsement Net Amount&nbsp;
                                <span className="danger">*</span>
                              </label>
                              <input
                                type="number"
                                onFocus={numberWheelChange}
                                className="form-control"
                                id="net_amount"
                                name="net_amount"
                                {...register("net_amount", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.net_amount && (
                                <ErrorLabel
                                  message={errors.net_amount?.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                GST %<span className="danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="gst_perc"
                                name="gst_perc"
                                defaultValue={18}
                                placeholder="Enter"
                                {...register("gst_perc", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.gst_perc && (
                                <ErrorLabel
                                  message={errors.gst_perc?.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                GST Amount (Tax Amount){" "}
                                <span className="danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="gst_amount"
                                name="gst_amount"
                                placeholder="Enter"
                                {...register("gst_amount", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.gst_amount && (
                                <ErrorLabel
                                  message={errors.gst_amount?.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                Endorsement Total Premium
                                <span className="danger">*</span>
                              </label>
                              <input
                                type="number"
                                onFocus={numberWheelChange}
                                className="form-control"
                                id="total_amount"
                                name="total_amount"
                                placeholder="Enter"
                                {...register("total_amount", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.total_amount && (
                                <ErrorLabel
                                  message={errors.total_amount?.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div class="form-group has-search">
                              <label for="payment_date" class="form-label">
                                Payment Date
                                <span class="text-danger">*</span>
                              </label>
                              <span class="fa fa-calendar form-control-feedback"></span>
                              <Controller
                                name="payment_date"
                                control={control}
                                render={({ field }) => (
                                  <Flatpickr
                                    {...field}
                                    onChange={(value) => {
                                      // console.log("Selected date:", value);
                                      var date = new Date(value).toISOString();
                                      // console.log("ISO date:", date);
                                      setValue(
                                        "payment_date",
                                        moment(date).format("DD-MM-YYYY")
                                      );
                                    }}
                                    id="disabled-picker"
                                    className="form-control"
                                    options={{
                                      dateFormat: "d-m-Y",
                                      enableTime: false,
                                      maxDate: "today", // Disables future dates
                                    }}
                                  />
                                )}
                                rules={{
                                  required: "This is required.",
                                }}
                              />
                              {errors.payment_date && (
                                <ErrorLabel
                                  message={errors.payment_date?.message}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                Paid Through&nbsp;
                                <span className="danger">*</span>
                              </label>
                              <select
                                className="form-control"
                                id="paid_through"
                                name="paid_through"
                                readOnly={initialData}
                                placeholder="Select.."
                                {...register("paid_through", {
                                  required: "This is required.",
                                })}
                              >
                                <option value="Self Paid">Self Paid</option>
                                <option value="CD Paid">CD Paid</option>
                              </select>
                              {errors.paid_through && (
                                <ErrorLabel
                                  message={errors.paid_through?.message}
                                />
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {/* END */}

                      <div className="col-12 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            COPS Remark&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="remark"
                            name="remark"
                            placeholder="Enter"
                            {...register("remark", {
                              required: "This is required.",
                            })}
                          />
                          {errors.remark && (
                            <ErrorLabel message={errors.remark?.message} />
                          )}
                        </div>
                      </div>
                      <>
                        <div className="col-12 mt-4">
                          <div
                            {...getRootProps2({ className: "dropzone" })}
                            className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                          >
                            <span className="badge bg-primary rounded p-2">
                              <input
                                accept=""
                                name="file"
                                {...getInputProps2()}
                              />
                              <i className="fa fa-plus" />
                            </span>{" "}
                            <span>Add Files</span>
                          </div>
                          <span
                            id="document_required"
                            className="d-none  text-danger fs-7 mx-auto "
                          >
                            {" "}
                            Document is required
                          </span>
                          {thumbs2}
                          {attachment2.length > 3 && (
                            <button
                              type="btn"
                              className="btn btn-primary rounded mt-4"
                              onClick={(e) => {
                                e.preventDefault();
                                removeAll2();
                              }}
                            >
                              Remove All
                            </button>
                          )}
                          {fileRejections2.length > 0 && (
                            <div className="mt-2">{fileRejectionItems2}</div>
                          )}

                        </div>
                        <div className="col-12 mt-1">
                          <div className="row">
                            {document && document.length > 0 ? (
                              document.map((objLink, index) => (
                                <>
                                  <div className="col-12 col-md-4 col-xl-3">
                                    <div className="card shadow bg-light rounded mb-1 ">
                                      <div className="card-body d-flex justify-content-between py-1">
                                        <a
                                          className="primary"
                                          onClick={async () => {
                                            try {
                                              const pdfres = await dispatch(actionDownload({ dmsIds: [objLink?.id] })).unwrap();

                                              const pdfUrl = pdfres?.data?.urls?.[0]?.url;

                                              if (pdfUrl) {
                                                window.open(pdfUrl, "_blank");
                                              } else {
                                                alert("PDF link not available");
                                              }
                                            } catch (err) {
                                              alert("Failed to fetch PDF link");
                                            }
                                          }}
                                        >
                                          {objLink.actual_uploaded_file_name}
                                        </a>

                                        <span className="cursor-pointer">
                                          {" "}
                                          <i
                                            size={16}
                                            className="fa fa-trash btn btn-sm primary2"
                                            onClick={() => {
                                              Swal.fire({
                                                icon: "warning",
                                                text: "Are you sure, you want to delete this document?",
                                                cancelButtonText: "Cancel",
                                                showCancelButton: true,
                                              }).then(({ isConfirmed }) => {
                                                if (isConfirmed) {
                                                  $(
                                                    "#progress-loader"
                                                  ).removeClass("hidden");
                                                  // props.actionDeleteDocument({
                                                  //   policy_id:
                                                  //     proposalPoolViewDetails?.id,
                                                  //   dms_id: objLink?.id,
                                                  // });
                                                }
                                              });
                                            }}
                                          ></i>
                                        </span>
                                        <a
                                          id="downloadLink"
                                          className="d-none"
                                        ></a>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                  <div className="form-actions border-0 float-none mt-1">
                    {
                      loading ?
                        <button
                          id="add_edit_endorsement"
                          className="btn btn-primary shadow round text-uppercase me-2"
                          type="submit"
                        >
                          <div className="d-flex align-items-center">
                            Submit
                            <span
                              id="add-edit-endorsement-loader"
                              className="spinner-border spinner-border-sm ml-half hidden"
                            ></span>
                          </div>
                        </button>
                        :
                        <button
                          id="add_edit_endorsement"
                          className="btn btn-primary shadow round text-uppercase me-2"
                          type="submit"
                        >
                          <div className="d-flex align-items-center">
                            Submit
                          </div>
                        </button>
                    }
                    <button
                      className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                      onClick={(event) => {
                        event.preventDefault();
                        navigate(-1);
                      }}
                    >
                      {" "}
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EndorsementForm;
